import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Save } from 'lucide-react'
import { exchangeSettingsSchema } from '../types'
import type { ExchangeSettingsFormData } from '../types'

interface ExchangeSettingsFormProps {
  defaultValues: ExchangeSettingsFormData
  onSubmit: (data: ExchangeSettingsFormData) => void
  isSubmitting: boolean
}

export function ExchangeSettingsForm({
  defaultValues,
  onSubmit,
  isSubmitting,
}: ExchangeSettingsFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ExchangeSettingsFormData>({
    resolver: zodResolver(exchangeSettingsSchema),
    defaultValues,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Mínimo puntos a canjear
        </label>
        <input
          {...register('min_exchange_points', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.min_exchange_points && (
          <p className="text-red-500 text-sm mt-1">{errors.min_exchange_points.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Valor de canje (punto a CLP)
        </label>
        <input
          {...register('value_point_to_CLP', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.value_point_to_CLP && (
          <p className="text-red-500 text-sm mt-1">{errors.value_point_to_CLP.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Valor de acumulación (CLP a punto)
        </label>
        <input
          {...register('value_CLP_to_point', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.value_CLP_to_point && (
          <p className="text-red-500 text-sm mt-1">{errors.value_CLP_to_point.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Vigencia de puntos (meses)
        </label>
        <input
          {...register('months_expiration_points', { valueAsNumber: true })}
          type="number"
          className="input"
        />
        {errors.months_expiration_points && (
          <p className="text-red-500 text-sm mt-1">{errors.months_expiration_points.message}</p>
        )}
      </div>

      <button type="submit" disabled={isSubmitting} className="btn btn-primary flex items-center gap-1.5">
        <Save size={16} />
        {isSubmitting ? 'Guardando...' : 'Guardar'}
      </button>
    </form>
  )
}
